import { useState, useEffect } from "react";
import Topbar from "../Topbar/Topbar";
import Sidebar from "../Sidebar/Sidebar";
import { useNavigate, useLocation } from "react-router-dom";
import {
  getDeptListApi,
  getEditApi,
  getFieldListApi,
  getfielsApi,
  getGateListApi,
  getOptionsListApi,
  registerSubmitApi,
  UpdateFieldsApi,
  getLocationListApi,
} from "./registerfield-api";
import { Col, Row, Toast, ToastContainer } from "react-bootstrap";
import AsyncSelect from "react-select/async";

const Registerfieldsadd = () => {
  //useLocation
  const location = useLocation();
  const { id } = location.state || {};

  const [activeTab, setActiveTab] = useState("Visitor");
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const [fieldOptions, setfieldOptions] = useState([]);
  const [fieldName, setFieldName] = useState([]);
  const apiUrl = process.env.REACT_APP_API_URL;
  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [lockedFields, setLockedFields] = useState(["Title", "Project"]);

  const isCoreField = (fieldName) => {
    if (!fieldName) return false;
    const clean = String(fieldName).trim().toLowerCase();
    const allLocked =
      Array.isArray(lockedFields) && lockedFields.length > 0
        ? lockedFields
        : ["Title", "Project"];
    return allLocked.some((f) => String(f).trim().toLowerCase() === clean);
  };

  const [validations, setValidations] = useState({
    code: "",
    name: "",
    locations: "",
    fields: "",
  });

  // const handleToggle = (option) => {
  //   const updatedFields = fieldOptions.map((field) => (field.field_name === option.field_name ? { ...field, enabled: !field.enabled } : field));

  //   setfieldOptions(updatedFields);
  // };
  // const handleMandToggle = (option) => {
  //   const updatedFields = fieldOptions.map((field) => (field.field_name === option.field_name ? { ...field, mandatory: !field.mandatory } : field));

  //   setfieldOptions(updatedFields);
  // };

  const multiselectCustomStyles = {
    valueContainer: (provided) => ({
      ...provided,
      maxHeight: "100px", // limit the height of selected items area
      overflowY: "auto", // add scroll if content exceeds
    }),
    menu: (provided) => ({
      ...provided,
      maxHeight: "200px", // limit the dropdown height
    }),
    control: (provided) => ({
      ...provided,
      backgroundColor: "#ffffff",
      borderRadius: "8px",
      border: "0.7px solid #E5E5E5",
      padding: "2px",
      fontWeight: "500",
      fontSize: "13px",
      color: "#212129",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#007bff"
        : state.isFocused
          ? "#e0e0e0"
          : "#fff",
      color: state.isSelected ? "#fff" : "#333",
      padding: 10,
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#F6F7F8",
      color: "#212129",
      borderRadius: "5px",
      padding: "2px 5px",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#212129",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "#212129",
      cursor: "pointer",
      ":hover": {
        backgroundColor: "red",
        color: "white",
      },
    }),
  };

  const submitform = async (value) => {
    const payload = {
      code: code,
      name: name,
      locations:
        locationOptions != null && locationOptions.map((item) => item.value),
      fields: ticketOptions.map((item) => {
        const isCore = isCoreField(item.field_name);
        const isEnabled = isCore ? true : !!item.enabled;
        return {
          field_name: item.field_name,
          enabled: isEnabled,
          mandatory: isCore ? true : (isEnabled ? !!item.mandatory : false),
          in_report: isCore ? true : !!item.in_report,
          report_label: item.report_label ? item.report_label.trim() : "",
          application_label: item.application_label
            ? item.application_label.trim()
            : "",
        };
      }),
    };
    let response;
    if (id != null) {
      response = await UpdateFieldsApi(payload, id);
      navigate("/register/list");
    } else {
      response = await registerSubmitApi(payload);
    }
    console.log(response, "response");
    console.log("response.status", response.status);

    if (response.data.success === true) {
      setSnackbarMessage(response.data.message);
      setSnackbarStatus(response.data.status);
      handleSnackbarShow();
      navigate("/register/list");

      setValidations({
        code: "",
        name: "",
        locations: "",
        fields: "",
      });
    }

    if (response.status === 400) {
      new Promise((resolve, reject) => {
        const validationTemp = {
          code: "",
          name: "",
          locations: "",
          fields: "",
        };
        Object.entries(response.data.error).forEach(([key, value]) => {
          console.log(`${key}: ${value}`);
          validationTemp[key] = value.length === 0 ? "" : value[0];
        });
        console.log("validationTemp...", validationTemp);
        setValidations(validationTemp);
      });
    }
  };

  useEffect(() => {
    if (id != null) {
      getFieldsDetails();
    } else {
      getFieldList();
    }
  }, []);

  const getFieldsDetails = async () => {
    try {
      const response = await getEditApi(id);
      console.log(response);
      if (response.status === true || response.config != null) {
        const config = response.config; // Get the first call

        setCode(config.code);
        setName(config.name);
        setLocationOptions(config.locations);

        if (config.default_fields && Array.isArray(config.default_fields)) {
          setLockedFields(config.default_fields);
        }

        setTicketOptions(
          (config.fields || []).map((field) => {
            const isCore = isCoreField(field.field_name);
            const isEnabled = isCore ? true : !!field.enabled;
            return {
              ...field,
              enabled: isEnabled,
              mandatory: isCore ? true : (isEnabled ? !!field.mandatory : false),
              in_report: isCore
                ? true
                : field.in_report !== undefined && field.in_report !== null
                  ? !!field.in_report
                  : true,
              report_label: field.report_label || "",
              application_label: field.application_label || "",
            };
          }),
        );
      }
    } catch (err) {
      console.error("Error fetching call details:", err);
    }
  };
  const navigate = useNavigate();

  //Gate
  const [locationOptions, setLocationOptions] = useState([]);
  const fetchLocation = (inputValue, callback) => {
    setTimeout(async () => {
      console.log("Fetching transport options with term:", inputValue);
      const response = await getLocationListApi(inputValue);
      if (response.status === 200) {
        if (response.data.success === true) {
          const options = response.data.suggestionlist.map((item) => ({
            value: String(item.value),
            label: String(item.label),
          }));
          callback(options);
        }
      }
    }, 1000);
  };

  const handleLocationChange = (selectedOptions) => {
    setLocationOptions(selectedOptions);
  };

  //Department
  const [department, setDepartment] = useState([]);
  const fetchDepartment = (inputValue, callback) => {
    setTimeout(async () => {
      console.log("Fetching department options with term:", inputValue);
      const response = await getDeptListApi(inputValue);
      if (response.status === 200) {
        if (response.data.success === true) {
          const options = response.data.suggestionlist.map((item) => ({
            value: String(item.value),
            label: String(item.label),
          }));
          callback(options);
        }
      }
    }, 1000);
  };

  const handleDepartmentChange = (selectedOptions) => {
    setDepartment(selectedOptions);
  };

  const getFieldList = async () => {
    try {
      const response = await getFieldListApi();
      if (response.data.success === true) {
        if (
          response.data.default_fields &&
          Array.isArray(response.data.default_fields)
        ) {
          setLockedFields(response.data.default_fields);
        }
        setTicketOptions(
          response.data.fields.map((field) => {
            const fieldName = field.field_name || field;
            const isCore = isCoreField(fieldName);
            const isEnabled = isCore ? true : !!field.enabled;
            return {
              field_name: fieldName,
              enabled: isEnabled,
              mandatory: isCore ? true : (isEnabled ? !!field.mandatory : false),
              in_report: isCore ? true : (field.in_report ?? true),
              report_label: field.report_label || "",
              application_label: field.application_label || "",
            };
          }),
        );
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const [options, setOptions] = useState([]);
  const [visitorDataFetched, setVisitorDataFetched] = useState(false);
  const [vehicleDataFetched, setVehicleDataFetched] = useState(false);

  const getOptionData = async (tab) => {
    try {
      const response = await getOptionsListApi(tab);
      if (response.data.success === true) {
        const transformed = response.data.fields.map((field) => {
          const isEnabled = !!field.enabled;
          return {
            field_name: field.field_name || field, // adapt to API shape
            enabled: isEnabled,
            mandatory: isEnabled ? !!field.mandatory : false,
          };
        });

        if (tab === "Visitor" && !visitorDataFetched) {
          setTicketOptions(transformed);
          setVisitorDataFetched(true);
        } else if (tab === "Vehicle" && !vehicleDataFetched) {
          setVehicleOptions(transformed);
          setVehicleDataFetched(true);
        }
      }
    } catch (err) {
      console.error("Error fetching fields:", err);
    }
  };

  // const getFields = async (value) => {
  //   try {
  //     const response = await getfielsApi(value);
  //     console.log("fields");
  //     console.log(response);
  //     if (response.success === true) {
  //       setfieldOptions([]);
  //       console.log("fieldOptions test", fieldOptions);
  //       setfieldOptions(response.fields);
  //       console.log("fieldOptions test", fieldOptions);
  //     }
  //   } catch (err) {
  //     console.error("Error fetching category:", err);
  //   } finally {
  //   }
  // };

  useEffect(() => {
    /* getListData(); */
    //getFields(activeTab);
  }, []);

  //Toggle and mandatory toggle

  const handleToggle = (selectedOption) => {
    if (isCoreField(selectedOption.field_name)) return;
    const update = (list) =>
      list.map((opt) =>
        opt.field_name === selectedOption.field_name
          ? { ...opt, enabled: !opt.enabled, mandatory: false }
          : opt,
      );

    setTicketOptions((prev) => update(prev));
  };

  const handleMandToggle = (selectedOption) => {
    if (isCoreField(selectedOption.field_name)) return;
    if (!selectedOption.enabled) return;
    const update = (list) =>
      list.map((opt) =>
        opt.field_name === selectedOption.field_name
          ? { ...opt, mandatory: !opt.mandatory }
          : opt,
      );

    setTicketOptions((prev) => update(prev));
  };

  const handleReportToggle = (selectedOption) => {
    if (isCoreField(selectedOption.field_name)) return;
    const update = (list) =>
      list.map((opt) =>
        opt.field_name === selectedOption.field_name
          ? { ...opt, in_report: !opt.in_report }
          : opt,
      );

    setTicketOptions((prev) => update(prev));
  };

  const handleReportLabelChange = (selectedOption, value) => {
    const update = (list) =>
      list.map((opt) =>
        opt.field_name === selectedOption.field_name
          ? { ...opt, report_label: value }
          : opt,
      );

    setTicketOptions((prev) => update(prev));
  };

  const handleAppLabelChange = (selectedOption, value) => {
    const update = (list) =>
      list.map((opt) =>
        opt.field_name === selectedOption.field_name
          ? { ...opt, application_label: value }
          : opt,
      );

    setTicketOptions((prev) => update(prev));
  };

  const [ticketOptions, setTicketOptions] = useState([]);
  const [vehicleOptions, setVehicleOptions] = useState([]);

  // Select all helper states & handlers
  const isAllFieldsEnabled =
    ticketOptions.length > 0 && ticketOptions.every((opt) => opt.enabled);

  const handleToggleAllFields = () => {
    const nonCoreFields = ticketOptions.filter(
      (opt) => !isCoreField(opt.field_name),
    );
    const allNonCoreEnabled =
      nonCoreFields.length > 0 &&
      nonCoreFields.every((opt) => opt.enabled);
    const nextState = !allNonCoreEnabled;
    setTicketOptions((prev) =>
      prev.map((opt) => {
        if (isCoreField(opt.field_name)) {
          return { ...opt, enabled: true, mandatory: true };
        }
        return {
          ...opt,
          enabled: nextState,
          mandatory: nextState ? opt.mandatory : false,
        };
      }),
    );
  };

  const enabledFields = ticketOptions.filter((opt) => opt.enabled);
  const isAllMandatory =
    enabledFields.length > 0 && enabledFields.every((opt) => opt.mandatory);

  const handleToggleAllMandatory = () => {
    const currentEnabledNonCore = ticketOptions.filter(
      (opt) => opt.enabled && !isCoreField(opt.field_name),
    );
    if (currentEnabledNonCore.length === 0) {
      // Cannot set mandatory if no fields are enabled
      return;
    }
    const allNonCoreMandatory =
      currentEnabledNonCore.length > 0 &&
      currentEnabledNonCore.every((opt) => opt.mandatory);
    const nextState = !allNonCoreMandatory;
    setTicketOptions((prev) =>
      prev.map((opt) => {
        if (isCoreField(opt.field_name)) {
          return { ...opt, enabled: true, mandatory: true };
        }
        return opt.enabled
          ? { ...opt, mandatory: nextState }
          : { ...opt, mandatory: false };
      }),
    );
  };

  const nonCoreFields = ticketOptions.filter(
    (opt) => !isCoreField(opt.field_name),
  );
  const isAllReport =
    nonCoreFields.length > 0 &&
    nonCoreFields.every((opt) => opt.in_report);

  const handleToggleAllReport = () => {
    const nextState = !isAllReport;
    setTicketOptions((prev) =>
      prev.map((opt) => {
        if (isCoreField(opt.field_name)) {
          return { ...opt, in_report: true };
        }
        return {
          ...opt,
          in_report: nextState,
        };
      }),
    );
  };

  return (
    <div style={{ fontFamily: "Satoshi" }}>
      <div style={{ display: "flex" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            padding: "20px",
            backgroundColor: "#FFFFFF",
          }}
        >
          <div style={{ marginBottom: "40px" }}>
            <Row
              className="align-items-center"
              style={{ marginBottom: "32px" }}
            >
              <Col xs={12} md={6}>
                <div
                  style={{
                    fontWeight: "700",
                    fontSize: "20px",
                    color: "#172b4d",
                  }}
                >
                  Create new template
                </div>
              </Col>
              <Col xs={12} md={6}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    gap: "12px",
                    flexWrap: "wrap",
                  }}
                >
                  <button
                    style={{
                      borderRadius: "100px",
                      border: "0.6px solid #E5E5E5",
                      padding: "10px 28px 10px 28px",
                      backgroundColor: "#FFFFFF",
                      fontFamily: "Satoshi",
                      fontWeight: "700",
                      fontSize: "14px",
                      lineHeight: "18.9px",
                      color: "#21272C",
                    }}
                    onClick={() => navigate("/register/list")}
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() => submitform()}
                    style={{
                      borderRadius: "100px",
                      border: "0.6px solid #E5E5E5",
                      padding: "10px 28px 10px 28px",
                      backgroundColor: "#3253EB",
                      fontFamily: "Satoshi",
                      fontWeight: "700",
                      fontSize: "14px",
                      lineHeight: "18.9px",
                      color: "#FFFFFF",
                    }}
                  >
                    Save
                  </button>
                </div>
              </Col>
            </Row>

            <Row className="align-items-center" style={{ width: "100%" }}>
              <Col sm={12} md={6} lg={3}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                  }}
                >
                  <div
                    style={{
                      fontWeight: "500",
                      fontSize: "13px",
                      color: "#212129",
                    }}
                  >
                    Code <span style={{ color: "#ff4444" }}>*</span>
                  </div>
                  <div>
                    <input
                      type="text"
                      placeholder="Enter code"
                      value={code}
                      onChange={(e) => setCode(e.target.value)}
                      style={{
                        border:
                          code && code.trim() !== ""
                            ? "1.3px solid #6929E2"
                            : "1.3px solid #E5E5E5",
                        borderRadius: "10px",
                        padding: "16px",
                        height: "40px",
                        backgroundColor: "#ffffff",
                        fontWeight: "400",
                        fontSize: "13px",
                        color: "#212129",
                        width: "100%",
                        outline: "none",
                        transition: "border-color 0.2s ease",
                      }}
                    />
                    <span
                      style={{
                        fontWeight: "400",
                        fontSize: "12px",
                        color: "#ff4444",
                      }}
                    >
                      {validations.code}
                    </span>
                  </div>
                </div>
              </Col>

              <Col sm={12} md={6} lg={3}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                  }}
                >
                  <div
                    style={{
                      fontWeight: "500",
                      fontSize: "13px",
                      color: "#212129",
                    }}
                  >
                    Template Name <span style={{ color: "#ff4444" }}>*</span>
                  </div>
                  <div>
                    <input
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      type="text"
                      placeholder="Enter template name"
                      style={{
                        border:
                          name && name.trim() !== ""
                            ? "1.3px solid #6929E2"
                            : "1.3px solid #E5E5E5",
                        borderRadius: "10px",
                        padding: "16px",
                        height: "40px",
                        backgroundColor: "#ffffff",
                        fontWeight: "400",
                        fontSize: "13px",
                        color: "#212129",
                        width: "100%",
                        outline: "none",
                        transition: "border-color 0.2s ease",
                      }}
                    />
                    <span
                      style={{
                        fontWeight: "400",
                        fontSize: "12px",
                        color: "#ff4444",
                      }}
                    >
                      {validations.name}
                    </span>
                  </div>
                </div>
              </Col>

              <Col sm={12} md={6} lg={3}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                  }}
                >
                  <div
                    style={{
                      fontWeight: "500",
                      fontSize: "13px",
                      color: "#212129",
                    }}
                  >
                    Location
                  </div>
                  <div style={{ maxHeight: "150px" }}>
                    <AsyncSelect
                      isMulti
                      cacheOptions
                      value={locationOptions}
                      loadOptions={fetchLocation}
                      onChange={handleLocationChange}
                      defaultOptions
                      placeholder="Search location..."
                      styles={multiselectCustomStyles}
                      isClearable={false}
                    />
                  </div>
                  <span
                    style={{
                      fontWeight: "400",
                      fontSize: "12px",
                      color: "#ff4444",
                    }}
                  >
                    {validations.locations}
                  </span>
                </div>
              </Col>

              {/* <Col sm={12} md={6} lg={3}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                  }}
                >
                  <div
                    style={{
                      fontWeight: "500",
                      fontSize: "13px",
                      color: "#212129",
                    }}
                  >
                    Department
                  </div>
                  <div>
                    <AsyncSelect
                      isMulti
                      cacheOptions
                      value={department}
                      loadOptions={fetchDepartment}
                      onChange={handleDepartmentChange}
                      defaultOptions
                      placeholder="Search department..."
                      styles={multiselectCustomStyles}
                      isClearable={false}
                    />
                  </div>
                </div>
              </Col> */}
            </Row>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "16",
            }}
          >
            {/*  <div>
              <div
                style={{
                  fontWeight: "700",
                  fontSize: "20px",
                  color: "#172b4d",
                }}
              >
                Register Fields
              </div>
              <div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    borderLeft: "1px dashed #626F86",
                  }}
                >

                  <div style={{ borderRadius: "8px", visibility: "hidden" }}>
                    Ticket
                  </div>
                </div>
                {fieldName.map((label) => (
                  <div
                    key={label}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      borderLeft: "1px dashed #626F86",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setActiveTab(label);
                      if (id == null) {
                        getOptionData(label);
                      }
                    }}
                  >
                    <div
                      style={{
                        border: "1px dashed #626F86",
                        width: "20px",
                        height: "0px",
                      }}
                    ></div>
                    <div
                      style={{
                        borderRadius: "8px",
                        padding: "10px 8px 10px 12px",
                        backgroundColor: activeTab === label ? "#F4F0FF" : "",
                        border: activeTab === label ? "1px dashed #6929E2" : "",
                        color: activeTab === label ? "#6929E2" : "#000",
                        transition: "all 0.2s ease-in-out",
                        width: "100%",
                      }}
                    >
                      {label}
                    </div>
                  </div>
                ))}
              </div>
            </div> */}

            <div
              style={{
                borderRadius: "16px",
                padding: "20px 16px 16px 16px",
                backgroundColor: "#F8F8F8",
                border: "1px solid #E5E5E5",
                display: "flex",
                flexDirection: "column",
                gap: "12px",
                width: "100%",
              }}
            >
              {/* <div
                style={{
                  marginTop: "6px",
                  fontWeight: "700",
                  fontSize: "14px",
                  color: "#6929E2",
                  textAlign: "center",
                }}
              >
                {activeTab.toUpperCase()}
              </div> */}

              <div>
                <div
                  style={{
                    marginBottom: "12px",
                    fontWeight: "600",
                    fontSize: "13px",
                    color: "#8790A1",
                  }}
                >
                  Configurations
                </div>

                <span
                  style={{
                    fontWeight: "400",
                    fontSize: "12px",
                    color: "#ff4444",
                  }}
                >
                  {validations.fields}
                </span>

                <div
                  style={{
                    backgroundColor: "#FFFFFF",
                    borderRadius: "10px",
                    border: "1px solid #E5E5E5",
                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.03)",
                    overflowX: "auto",
                  }}
                >
                  <table
                    style={{
                      width: "100%",
                      minWidth: "860px",
                      tableLayout: "fixed",
                      borderCollapse: "collapse",
                      textAlign: "left",
                    }}
                  >
                    <colgroup>
                      <col style={{ width: "22%" }} />
                      <col style={{ width: "14%" }} />
                      <col style={{ width: "18%" }} />
                      <col style={{ width: "23%" }} />
                      <col style={{ width: "23%" }} />
                    </colgroup>
                    <thead>
                      <tr
                        style={{
                          backgroundColor: "#FFFFFF",
                          borderBottom: "1px solid #E5E5E5",
                        }}
                      >
                        {/* 1. Field Name with Select All Checkbox (22%) */}
                        <th
                          style={{
                            padding: "13px 18px",
                            width: "22%",
                            verticalAlign: "middle",
                          }}
                        >
                          <label
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "8px",
                              margin: 0,
                              cursor: "pointer",
                              minHeight: "22px",
                            }}
                            title={
                              isAllFieldsEnabled
                                ? "Unselect all fields"
                                : "Select all fields"
                            }
                          >
                            <input
                              type="checkbox"
                              checked={isAllFieldsEnabled}
                              onChange={handleToggleAllFields}
                              style={{
                                width: "16px",
                                height: "16px",
                                accentColor: "#6929E2",
                                cursor: "pointer",
                                margin: 0,
                                borderRadius: "4px",
                              }}
                            />
                            <span
                              style={{
                                fontSize: "13.5px",
                                fontWeight: "600",
                                color: "#212129",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Field Name
                            </span>
                          </label>
                        </th>

                        {/* 2. Mandatory with Select All Toggle (14%) */}
                        <th
                          style={{
                            padding: "13px 14px",
                            width: "14%",
                            verticalAlign: "middle",
                          }}
                        >
                          <label
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "8px",
                              margin: 0,
                              cursor:
                                enabledFields.length > 0
                                  ? "pointer"
                                  : "not-allowed",
                              opacity: enabledFields.length > 0 ? 1 : 0.4,
                              minHeight: "22px",
                            }}
                            title={
                              enabledFields.length === 0
                                ? "Enable at least one field to set mandatory"
                                : isAllMandatory
                                ? "Unselect all mandatory"
                                : "Select all mandatory"
                            }
                          >
                            <div
                              style={{
                                position: "relative",
                                width: "28px",
                                height: "16px",
                                borderRadius: "20px",
                                backgroundColor: isAllMandatory
                                  ? "#6929E2"
                                  : "#D1D5DB",
                                transition: "background-color 0.2s",
                                cursor:
                                  enabledFields.length > 0
                                    ? "pointer"
                                    : "not-allowed",
                                flexShrink: 0,
                              }}
                            >
                              <input
                                type="checkbox"
                                disabled={enabledFields.length === 0}
                                checked={isAllMandatory}
                                onChange={handleToggleAllMandatory}
                                style={{
                                  opacity: 0,
                                  width: 0,
                                  height: 0,
                                  position: "absolute",
                                }}
                              />
                              <div
                                style={{
                                  position: "absolute",
                                  top: "2px",
                                  left: isAllMandatory ? "14px" : "2px",
                                  width: "12px",
                                  height: "12px",
                                  borderRadius: "50%",
                                  backgroundColor: "#FFFFFF",
                                  transition: "left 0.2s",
                                  boxShadow:
                                    "0 1px 2px rgba(0, 0, 0, 0.2)",
                                }}
                              />
                            </div>
                            <span
                              style={{
                                fontSize: "13.5px",
                                fontWeight: "600",
                                color: "#212129",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Mandatory
                            </span>
                          </label>
                        </th>

                        {/* 3. Include in Report with Select All Toggle (18%) */}
                        <th
                          style={{
                            padding: "13px 14px",
                            width: "18%",
                            verticalAlign: "middle",
                          }}
                        >
                          <label
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "8px",
                              margin: 0,
                              cursor: "pointer",
                              whiteSpace: "nowrap",
                              minHeight: "22px",
                            }}
                            title={
                              isAllReport
                                ? "Unselect all in report"
                                : "Select all in report"
                            }
                          >
                            <div
                              style={{
                                position: "relative",
                                width: "28px",
                                height: "16px",
                                borderRadius: "20px",
                                backgroundColor: isAllReport
                                  ? "#6929E2"
                                  : "#D1D5DB",
                                transition: "background-color 0.2s",
                                cursor: "pointer",
                                flexShrink: 0,
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={isAllReport}
                                onChange={handleToggleAllReport}
                                style={{
                                  opacity: 0,
                                  width: 0,
                                  height: 0,
                                  position: "absolute",
                                }}
                              />
                              <div
                                style={{
                                  position: "absolute",
                                  top: "2px",
                                  left: isAllReport ? "14px" : "2px",
                                  width: "12px",
                                  height: "12px",
                                  borderRadius: "50%",
                                  backgroundColor: "#FFFFFF",
                                  transition: "left 0.2s",
                                  boxShadow:
                                    "0 1px 2px rgba(0, 0, 0, 0.2)",
                                }}
                              />
                            </div>
                            <span
                              style={{
                                fontSize: "13.5px",
                                fontWeight: "600",
                                color: "#212129",
                                whiteSpace: "nowrap",
                              }}
                            >
                              In Report
                            </span>
                          </label>
                        </th>

                        {/* 4. Application Label (23%) */}
                        <th
                          style={{
                            padding: "13px 14px",
                            width: "23%",
                            verticalAlign: "middle",
                          }}
                        >
                          <div
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              minHeight: "22px",
                            }}
                          >
                            <span
                              style={{
                                fontSize: "13.5px",
                                fontWeight: "600",
                                color: "#212129",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Application Label
                            </span>
                          </div>
                        </th>

                        {/* 5. Report Label (23%) */}
                        <th
                          style={{
                            padding: "13px 14px",
                            width: "23%",
                            verticalAlign: "middle",
                          }}
                        >
                          <div
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              minHeight: "22px",
                            }}
                          >
                            <span
                              style={{
                                fontSize: "13.5px",
                                fontWeight: "600",
                                color: "#212129",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Report Label
                            </span>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {ticketOptions.map((option, idx) => (
                        <tr
                          key={option.field_name}
                          style={{
                            borderBottom: "none",
                            backgroundColor: !option.enabled
                              ? "#FAFAFA"
                              : "#FFFFFF",
                            transition: "background-color 0.15s ease",
                          }}
                        >
                          {/* 1. Field Name with Enable Checkbox */}
                          <td
                            style={{
                              padding: "10px 18px",
                              verticalAlign: "middle",
                            }}
                          >
                            <label
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "10px",
                                margin: 0,
                                cursor: isCoreField(option.field_name)
                                  ? "not-allowed"
                                  : "pointer",
                              }}
                              title={
                                isCoreField(option.field_name)
                                  ? "Default field: Always enabled and mandatory"
                                  : undefined
                              }
                            >
                              <input
                                type="checkbox"
                                checked={
                                  isCoreField(option.field_name)
                                    ? true
                                    : option.enabled
                                }
                                disabled={isCoreField(option.field_name)}
                                onChange={() => handleToggle(option)}
                                style={{
                                  width: "17px",
                                  height: "17px",
                                  accentColor: "#6929E2",
                                  cursor: isCoreField(option.field_name)
                                    ? "not-allowed"
                                    : "pointer",
                                  margin: 0,
                                  borderRadius: "4px",
                                  opacity: isCoreField(option.field_name)
                                    ? 0.75
                                    : 1,
                                }}
                              />

                              <span
                                style={{
                                  fontWeight: "600",
                                  fontSize: "13px",
                                  color: option.enabled ? "#212129" : "#8790A1",
                                  userSelect: "none",
                                  maxWidth: "240px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  display: "inline-block",
                                  verticalAlign: "middle",
                                }}
                                title={option.field_name}
                              >
                                {option.field_name}
                              </span>
                              {isCoreField(option.field_name) && (
                                <span
                                  style={{
                                    fontSize: "10.5px",
                                    fontWeight: "600",
                                    color: "#6929E2",
                                    backgroundColor: "#F3E8FF",
                                    padding: "1px 7px",
                                    borderRadius: "10px",
                                    whiteSpace: "nowrap",
                                    border: "1px solid #E9D5FF",
                                  }}
                                  title="Default field: Always enabled and mandatory"
                                >
                                  Default
                                </span>
                              )}
                              {!option.enabled && !isCoreField(option.field_name) && (
                                <span
                                  style={{
                                    fontSize: "10.5px",
                                    fontWeight: "500",
                                    color: "#8790A1",
                                    backgroundColor: "#F4F5F7",
                                    padding: "1px 6px",
                                    borderRadius: "4px",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  Disabled
                                </span>
                              )}
                            </label>
                          </td>

                          {/* 2. Mandatory Toggle (Left-aligned) */}
                          <td
                            style={{
                              padding: "10px 14px",
                              verticalAlign: "middle",
                              textAlign: "left",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-start",
                              }}
                            >
                              <label
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  margin: 0,
                                  cursor: isCoreField(option.field_name)
                                    ? "not-allowed"
                                    : option.enabled
                                    ? "pointer"
                                    : "not-allowed",
                                  opacity: isCoreField(option.field_name)
                                    ? 0.85
                                    : option.enabled
                                    ? 1
                                    : 0.3,
                                  transition: "opacity 0.2s ease",
                                }}
                                title={
                                  isCoreField(option.field_name)
                                    ? "Default field: Always mandatory"
                                    : !option.enabled
                                    ? "Enable field to set mandatory"
                                    : option.mandatory
                                    ? "Mandatory: Yes"
                                    : "Mandatory: No"
                                }
                              >
                                <div
                                  style={{
                                    position: "relative",
                                    width: "32px",
                                    height: "18px",
                                    borderRadius: "20px",
                                    backgroundColor:
                                      isCoreField(option.field_name) ||
                                      (option.enabled && option.mandatory)
                                        ? "#6929E2"
                                        : "#D1D5DB",
                                    transition: "background-color 0.2s",
                                    cursor: isCoreField(option.field_name)
                                      ? "not-allowed"
                                      : option.enabled
                                      ? "pointer"
                                      : "not-allowed",
                                    flexShrink: 0,
                                  }}
                                >
                                  <input
                                    type="checkbox"
                                    disabled={
                                      isCoreField(option.field_name) ||
                                      !option.enabled
                                    }
                                    checked={
                                      isCoreField(option.field_name)
                                        ? true
                                        : option.enabled && !!option.mandatory
                                    }
                                    onChange={() => handleMandToggle(option)}
                                    style={{
                                      opacity: 0,
                                      width: 0,
                                      height: 0,
                                      position: "absolute",
                                    }}
                                  />
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: "2px",
                                      left:
                                        isCoreField(option.field_name) ||
                                        (option.enabled && option.mandatory)
                                          ? "16px"
                                          : "2px",
                                      width: "14px",
                                      height: "14px",
                                      borderRadius: "50%",
                                      backgroundColor: "#FFFFFF",
                                      transition: "left 0.2s",
                                      boxShadow:
                                        "0 1px 2px rgba(0, 0, 0, 0.2)",
                                    }}
                                  />
                                </div>
                              </label>
                            </div>
                          </td>

                          {/* 3. Include in Report Toggle (Left-aligned) */}
                          <td
                            style={{
                              padding: "10px 14px",
                              verticalAlign: "middle",
                              textAlign: "left",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-start",
                              }}
                            >
                              <label
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  margin: 0,
                                  cursor: isCoreField(option.field_name)
                                    ? "not-allowed"
                                    : "pointer",
                                  opacity: isCoreField(option.field_name)
                                    ? 0.7
                                    : 1,
                                  transition: "opacity 0.2s ease",
                                }}
                                title={
                                  isCoreField(option.field_name)
                                    ? "Default field: Always included in report"
                                    : option.in_report
                                    ? "In Report: Yes"
                                    : "In Report: No"
                                }
                              >
                                <div
                                  style={{
                                    position: "relative",
                                    width: "32px",
                                    height: "18px",
                                    borderRadius: "20px",
                                    backgroundColor:
                                      isCoreField(option.field_name) ||
                                      option.in_report
                                        ? "#6929E2"
                                        : "#D1D5DB",
                                    transition: "background-color 0.2s",
                                    cursor: isCoreField(option.field_name)
                                      ? "not-allowed"
                                      : "pointer",
                                    flexShrink: 0,
                                  }}
                                >
                                  <input
                                    type="checkbox"
                                    disabled={isCoreField(option.field_name)}
                                    checked={
                                      isCoreField(option.field_name)
                                        ? true
                                        : !!option.in_report
                                    }
                                    onChange={() => handleReportToggle(option)}
                                    style={{
                                      opacity: 0,
                                      width: 0,
                                      height: 0,
                                      position: "absolute",
                                    }}
                                  />
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: "2px",
                                      left:
                                        isCoreField(option.field_name) ||
                                        option.in_report
                                          ? "16px"
                                          : "2px",
                                      width: "14px",
                                      height: "14px",
                                      borderRadius: "50%",
                                      backgroundColor: "#FFFFFF",
                                      transition: "left 0.2s",
                                      boxShadow:
                                        "0 1px 2px rgba(0, 0, 0, 0.2)",
                                    }}
                                  />
                                </div>
                              </label>
                            </div>
                          </td>

                          {/* 4. Application Label (identical height and width) */}
                          <td
                            style={{
                              padding: "8px 14px",
                              verticalAlign: "middle",
                            }}
                          >
                            <input
                              type="text"
                              title={option.application_label || option.field_name}
                              placeholder={option.field_name}
                              value={option.application_label || ""}
                              onChange={(e) =>
                                handleAppLabelChange(option, e.target.value)
                              }
                              style={{
                                border:
                                  option.application_label &&
                                  option.application_label.trim() !== ""
                                    ? "1.3px solid #6929E2"
                                    : "1.3px solid #E5E5E5",
                                borderRadius: "8px",
                                padding: "8px 12px",
                                height: "38px",
                                backgroundColor: "#FFFFFF",
                                fontWeight: "400",
                                fontSize: "13px",
                                color: "#212129",
                                outline: "none",
                                width: "100%",
                                boxSizing: "border-box",
                                textOverflow: "ellipsis",
                                transition: "border-color 0.2s ease",
                              }}
                            />
                          </td>

                          {/* 5. Report Label (identical height and width) */}
                          <td
                            style={{
                              padding: "8px 14px",
                              verticalAlign: "middle",
                            }}
                          >
                            <input
                              type="text"
                              title={option.report_label || option.field_name}
                              placeholder={option.field_name}
                              value={option.report_label || ""}
                              onChange={(e) =>
                                handleReportLabelChange(option, e.target.value)
                              }
                              disabled={!option.in_report}
                              style={{
                                border:
                                  option.in_report &&
                                  option.report_label &&
                                  option.report_label.trim() !== ""
                                    ? "1.3px solid #6929E2"
                                    : "1.3px solid #E5E5E5",
                                borderRadius: "8px",
                                padding: "8px 12px",
                                height: "38px",
                                backgroundColor: option.in_report
                                  ? "#FFFFFF"
                                  : "#F8F8F8",
                                fontWeight: "400",
                                fontSize: "13px",
                                color: option.in_report ? "#212129" : "#8790A1",
                                outline: "none",
                                width: "100%",
                                boxSizing: "border-box",
                                textOverflow: "ellipsis",
                                cursor: option.in_report
                                  ? "text"
                                  : "not-allowed",
                                transition: "border-color 0.2s ease",
                              }}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div style={{ marginTop: "20px" }}>
                  {/* <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <button onClick={() => submitform()} style={{ borderRadius: "100px", border: "1px solid #E5E5E5", padding: "10px 28px", backgroundColor: "#6929E2", fontWeight: "700", fontSize: "14px", width: "160px", color: "#FFFFFF", cursor: "pointer" }}>
                      Update
                    </button>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer position="top-end">
          <Toast
            className="d-inline-block m-1"
            bg={snackbarStatus === true ? "success" : "danger"}
            show={showSnackbar}
            onClose={handleSnackbarClose}
            delay={3000}
            autohide
          >
            <Toast.Body style={{ color: "#ffffff" }}>
              {snackbarMessage}
            </Toast.Body>
          </Toast>
        </ToastContainer>
      </div>
    </div>
  );
};

export default Registerfieldsadd;
